import * as types from "./types";

const mutations = {
    [types.LOADING_EMAILTEMPLATE](state, value) {
        state.loading = value;
    },
    [types.GET_EMAILTEMPLATE_LIST](state, emailtemplate) {
        state.emailtemplate = emailtemplate;
    },
    [types.REMOVE_EMAILTEMPLATE](state, id) {        
        state.emailtemplate = state.emailtemplate.filter((x) => x.id !== id);        
    },
    [types.ADD_EMAILTEMPLATE](state, emailtemplate) {        
        state.emailtemplate.unshift(emailtemplate);
    },
    [types.UPDATE_EMAILTEMPLATE](state, emailtemplate) {        
        const TemplateIndex = state.emailtemplate.findIndex((x) => x.id === emailtemplate.id);
        state.emailtemplate[TemplateIndex] = emailtemplate;        
    },
    [types.GET_EMAILTEMPLATEID](state, id) {
        state.emailtemplateid = id;
    },
//platform type
    [types.GET_PLATFORM_TYPE](state, platform) {
        state.platformTypeList  = platform;
    },
    [types.ADD_CONTENT_TEMPLATE](state, content) {
        state.contentTemplate.unshift(content);
    },
    [types.GET_CONTENT_TEMPLATE](state, payload) {
        state.emailtemplate = payload; 
    },
    [types.GET_CONTENT_TEMPLATE_BY_ID](state, id) {
        state.contentTemplateId = id;
    },
    [types.UPDATE_CONTENT_TEMPLATE](state, contentTemplate) {
        const contentIndex = state.contentTemplate.findIndex((x) => x.id === contentTemplate.id);
        state.contentTemplate[contentIndex] = contentTemplate;
    },
    [types.DELETE_CONTENT_TEMPLATE](state, id) {
        state.contentTemplate = state.contentTemplate.filter((x) => x.id !== id);
    }
};

export default mutations;
